<template>
  <div>
    <Header></Header>
    <div class="contain_main sheader">
      <Title title="试题分类"></Title>
      <Button  @click="add(0)"  type="primary">添加一级分类</Button>
    </div>
    <div class="classmanage contain_main">
      <ul class="list">
        <li v-for="item in list" :key="item.qbid">
          <div class="item">
            <span @click="switchOn(item.qbid)" v-if="item.child">
              <Icon v-if="item.expand" type="ios-arrow-down"/>
              <Icon v-if="!item.expand" type="ios-arrow-up"/>
            </span>
            {{item.qbtitle}}
            <span class="operate">
              <Button type="primary"  @click="edit(item.qbid)" shape="circle" icon="md-create"></Button>
              <Button type="success" @click="add(item.qbid)" shape="circle" icon="md-add"></Button>
              <Button type="error" @click="del(item.qbid)" shape="circle" icon="ios-trash-outline"></Button>
            </span>
          </div>
          <ul class="mlist" v-show="item.expand">
            <li v-for="item in item.child" :key="item.qbid">
              <div class="item">
                <span @click="switchOn(item.qbid)" v-if="item.child" >
                  <Icon v-if="item.expand" type="ios-arrow-down"/>
                  <Icon v-if="!item.expand" type="ios-arrow-up"/>
                </span>
                {{item.qbtitle}}
                <span class="operate">
                  <Button type="primary" @click="edit(item.qbid)" shape="circle" icon="md-create"></Button>
                  <Button type="success" @click="add(item.qbid)" shape="circle" icon="md-add"></Button>
                  <Button type="error" @click="del(item.qbid)" shape="circle" icon="ios-trash-outline"></Button>
                </span>
              </div>
              <ul class="xlist" v-show="item.expand">
                <li v-for="item in item.child" :key="item.qbid">
                  <div class="item">
                    {{item.qbtitle}}
                    <span class="operate">
                      <Button type="primary" @click="edit(item.qbid)" shape="circle" icon="md-create"></Button>
                      <Button type="error" @click="del(item.qbid)" shape="circle" icon="ios-trash-outline"></Button>
                    </span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
       <classmanage v-if="showed" :type="type" :dataset="message" @success="success" @close="close"></classmanage>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { QuestionBasic_index,QuestionBasic_del } from "../../assets/js/api.js";
import classmanage from "../../components/toast/classmanage";
export default {
  data() {
    return {
      data: {
        // 名称	类型	必填	参数位置	默认值	备注
        title: null, 
      },
      list: [],
      showed:false,
      type:1,
      message:null,
    };
  },
  components: {
    Header,
    Title,
    classmanage
  },
  mounted() {
    this.getlist();
  },
  methods: {
    close(){
      this.showed=false
    },
    success() {
      this.close();
      this.getlist();
    },
    add(data){
      this.type = 1;
      this.message = data // 通过message来传递其id并带入父级
      this.showed = true
    },
    edit(data) {
      this.type = 2;
      this.message = data;
      this.showed = true;
    },
    del(data){
      if(!confirm("您确定删除该条信息？")) return;
      QuestionBasic_del({qbid:data}).then(
        res=>{
          if(res.data.code==200){
            this.$Notice.success({ title: '成功提示',desc:'删除成功！'});
            this.getlist()
            return 
          }
             this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      )
    },
    switchOn(switchon) {
      function rangedata(data) {
        if (data.length > 0) {
          data = data.map(item => {
            if (item.child) {
              item.child = rangedata(item.child);
            }
            if(item.qbid == switchon ){
               item.expand = !item.expand;
            }
            return item;
          });
          return data;
        } else {
          return;
        }
      }
      this.list =  rangedata(this.list)
    },
    getlist() {
      QuestionBasic_index().then(res => {
        if (res.data.code == 200) {
          function rangedata(data) {
            if (data.length > 0) {
              data = data.map(item => {
                item.expand = false;
                if (item.child) {
                  item.child = rangedata(item.child);
                }
                return item;
              });
              return data;
            } else {
              return;
            }
          }
          this.list = rangedata(res.data.data);
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });;
      });
    }
  }
};
</script>
<style lang="css" scoped>
.classmanage {
  margin-top: 40px;
}
.sheader{
  display: flex;
  align-items:flex-end;
  justify-content: space-around;
}
.list {
  text-align: left;
}
.item {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  font-weight: normal;
}
.mlist {
  padding-left: 2em;
}
.xlist {
  padding-left: 2em;
}
.operate {
  float: right;
}
.operate button {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/system/classManage.vue